import { getCurrencyUnicode } from "../../helperFunctions/util";
import useAdminDataStore, { selectCurrentGroupData } from "../../store/adminData/adminData";
import { useMemo } from "react";

const useCurrency = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const currency = useMemo(() => {
    if (groupData?.id) {
      const groupCurrencyISO = groupData?.paymentDetails?.currency || "USD";
      return getCurrencyUnicode(groupCurrencyISO);
    }
    return "$";
  }, [groupData?.id, groupData?.paymentDetails?.currency]);

  return currency;
};

export default useCurrency;
